import { IContact } from '../../model/types'

type ContactIdentity = Pick<IContact, 'contactId' | 'partnerId'>

export const getContactStateKey = ({ contactId, partnerId }: ContactIdentity) =>
  `${contactId}::${partnerId}`
